import { useFormContext } from 'react-hook-form'

import { DefaultElementProps } from 'common/interfaces'
import RadioGroupWrapper from 'components/RadioGroupWrapper'

import RadioItemWithImage from './components/RadioItemWithImage'
import { RadioGroupImage as RadioGroupProps, RadioImageOption } from './interface'

function radioOptions(options: RadioImageOption[]): JSX.Element[] {
  return options.map((option) => <RadioItemWithImage option={option} key={option.value} />)
}

export default function RadioGroupImage({
  name,
  size,
  label,
  textAlign,
  options,
  direction,
  defaultValue,
  validations,
  onChange,
  onFocus,
}: RadioGroupProps & DefaultElementProps): JSX.Element {
  const { control } = useFormContext()

  return (
    <RadioGroupWrapper
      classNames="radio-wrap-image"
      control={control}
      name={name}
      validations={validations}
      size={size}
      label={label}
      textAlign={textAlign}
      direction={direction}
      defaultValue={defaultValue}
      onFocus={onFocus}
      onChange={onChange}
      gapSize={2}
    >
      {radioOptions(options)}
    </RadioGroupWrapper>
  )
}
